/**
 * This function is used to get the name of a student.
 * If there only first name, it will return the first name.
 * If there only last name, it will return the last name.
 * If there is both first name and last name, it will return the first name and last name.
 * If there is no first name or last name, it will return username or email.
 */
export function getStudentDisplayName(student: {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  username: string | null;
}) {
  if (student?.firstName && student?.lastName) {
    return `${student.firstName} ${student.lastName}`;
  }

  if (student?.firstName) {
    return student.firstName;
  }

  if (student?.lastName) {
    return student.lastName;
  }

  return student?.username || student?.email || 'No student name';
}
